import React, { useEffect, useState } from "react";
import RFLayout from "@/layout/RFLayout";
import ActivityContext, {
  ActiivityContentProps,
} from "@/utils/actiivityContext";
import PullNewServices from "@/service/pullNew.service";
import directToClientLogin from "@/utils/directClientLogin";

interface ActivityLayoutProps {
  children: React.ReactNode;
}

export default function ActivityLayout({ children }: ActivityLayoutProps) {
  const [actiivityInfo, setActiivityInfo] = useState<ActiivityContentProps>({
    shareCode: "",
    userStatus: -1,
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // 取消相互依赖
      PullNewServices.getOpenBrokerStatus()
        .then((userStatusData) => {
          setActiivityInfo((pre) => ({ ...pre, userStatus: userStatusData }));
        })
        .catch((error) => {
          throw error;
        });

      PullNewServices.getShareCode()
        .then((shareCodeData) => {
          setActiivityInfo((pre) => ({ ...pre, shareCode: shareCodeData }));
        })
        .catch((error) => {
          throw error;
        });
    } catch (error: any) {
      if (error.code === 401) {
        directToClientLogin();
      }
    }
  };

  return (
    <RFLayout>
      <ActivityContext.Provider value={actiivityInfo}>
        {children}
      </ActivityContext.Provider>
    </RFLayout>
  );
}
